import { useQuery, useQueryClient } from "@tanstack/react-query";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import Calendar from "../../models/calendars/Calendar";
import { invalidateQuery } from "../utils";

const QUERY_KEY = "calendar";

/**
 * Hook to fetch a single calendar by ID.
 * Stale time set to 1 minute.
 */
export function useCalendar(calendarId = "") {
  return useQuery({
    queryKey: [QUERY_KEY, calendarId],
    enabled: !!calendarId,
    staleTime: 60_000,
    cacheTime: 5 * 60_000,
    queryFn: async () => {
      const ref = doc(db, "calendars", String(calendarId));
      const snapshot = await getDoc(ref);

      if (snapshot.exists()) {
        return new Calendar({ id: snapshot.id, ...snapshot.data() });
      }

      return null;
    },
    onError: (err) => {
      console.error("Failed to fetch calendar by ID.", err);
    },
  });
}

/**
 * Hook that returns a function to invalidate the query and cause it to refetch.
 */
export const useInvalidateCalendar = () => {
  const queryClient = useQueryClient();
  return (calendarId) => invalidateQuery({ queryClient, queryKey: QUERY_KEY, id: calendarId });
};
